import { createFileRoute } from "@tanstack/react-router";
import { DeptContentForm } from "@/components/dept-content/DeptContentForm";
import { CFRD_GALLERY } from "@/lib/deptContent";

function Edit() {
  const { id } = Route.useParams();
  return <DeptContentForm cfg={CFRD_GALLERY} id={id} />;
}

export const Route = createFileRoute("/_app/cfrd/gallery/$id")({
  component: Edit,
});
